import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { settings, getCurrentUser } from '@springtree/eva-sdk-redux';
import { AngularFusejsOptions } from 'angular-fusejs';
import { debounceTime, map, tap, filter } from 'rxjs/operators';
import { IListServiceItem, ListServicesService } from '../../services/list-services.service';
import { EndPointUrlService } from 'src/app/services/end-point-url.service';
import { fadeInOut } from 'src/app/shared/animations';
import { Observable } from 'rxjs';

interface IServicesFormValue {
  [type: string]: boolean;
}

@Component({
    selector: 'eva-services-selector',
    templateUrl: './services-selector.component.html',
    styleUrls: ['./services-selector.component.scss'],
    animations: [fadeInOut],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesSelectorComponent implements OnInit {

  private readonly portNumber: number;

  public readonly services$ = this.$listServices.services$.pipe(
    tap( services => {
      // Creating form controls for every service
      //
      services.forEach( service => {
        this.servicesForm.addControl( service.Type, this.formBuilder.control(false) );
      });
    })
  );

  public readonly loading$ = this.services$.pipe(
    map( services => services.length === 0  )
  );

  public searchOptions: AngularFusejsOptions = {
    keys: ['Name'],
    maximumScore: 0.5,
    shouldSort: true
  };

  public searchForm = this.formBuilder.group({
    search: [null]
  });

  public servicesForm = this.formBuilder.group({ });

  searchTerms: string;

  public get reducerIsSelected(): boolean {
    const reducerIsSelected = Object.keys(this.servicesForm.value)
      .filter(el => this.servicesForm.value[el] === true)
      .some(Boolean);

    return reducerIsSelected;
  }

  public get currentEndPoint(): string {
    return this.$endpoint.endPointUrl;
  }

  public loggedIn$: Observable<boolean> = getCurrentUser.getState$().pipe(
    map(state => state.isLoggedIn === true && !state.isFetching)
  );

  public userLoaded$: Observable<boolean> = getCurrentUser.isFetching$().pipe(
    map(isFetching => !isFetching)
  );

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    private $listServices: ListServicesService,
    private $endpoint: EndPointUrlService
  ) {
    this.portNumber = this.route.snapshot.params['portNumber'];

    this.searchForm.get('search')
    .valueChanges
    .pipe( debounceTime(300) )
    .subscribe((value: string) => {
      this.searchTerms = value;
    });
  }

  ngOnInit() {
  }

  createServices(values: IServicesFormValue) {
    /** The service types the user chose */
    const serviceTypes: string[] = Object.keys(values)
      .filter( el => values[el] === true );

    /** The entire service meta data the user chose, we want as much meta data about the service as possible */
    const services: IListServiceItem[] = this.$listServices.services$.value.filter( service => {
      return serviceTypes.includes(service.Type);
    });

    this.http.post(`http://localhost:${this.portNumber}/create`, {
      services: services,
      userToken: settings.userToken,
      endPoint: this.$endpoint.endPointUrl
     }).subscribe(() => {});
  }

  stopPropagation(mouseEvent: MouseEvent) {
    mouseEvent.stopPropagation();
  }

  programmaticallySelectFormControl(type: string) {
    const control = this.servicesForm.controls[type];

    const newValue = !control.value as boolean;

    control.setValue(newValue);
  }

}
